import { EXTERNAL_USER_Url } from "../const/URL";
import { IAddUserFormInput } from "../pages/settings/users/addUser/AddUser";
import hasRequestError from "../util/hasRequestError";
import axiosInstance from "./axiosInstance";

export const updateExternalUser = (obj: IAddUserFormInput) => {
  let objs = {
    id: obj.userId,
    name: obj.firstName + " " + obj.lastName,
    contactNumber: obj.contactNumber,
    isActive: obj.status,
    role: {
      id: obj.role,
    },
    customer: {
      id: obj.customer,
    },
    nickName: obj.nickName,
    title: obj.title,
  };

  return axiosInstance
    .put(EXTERNAL_USER_Url + "/user-id/" + obj.adminUser, objs)
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.message);
      }
      return response;
    });
};
